export default {
  certification: `profile/certification`,
  update: `profile/certification/update`,
  remove: `profile/certification/remove`,
};
